import { render, staticRenderFns } from "./TransferOutBalanceModal.vue?vue&type=template&id=b4ee9562&"
import script from "./TransferOutBalanceModal.vue?vue&type=script&lang=js&"
export * from "./TransferOutBalanceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports